





































import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { AgentTypeEnum, CountryEnum } from '@/api/types';
import { list_agent_summaries } from '@/api/agent';

type HeaderType = {
  text: string;
  value: string;
};

@Component({
  name: 'AgentListResult',
})
export default class extends Vue {
  @Prop({ required: true }) agents!: list_agent_summaries.AgentSummary[];
  private headers: HeaderType[] = [];
  private loading = false;
  private filterText = '';

  mounted() {
    this.loadHeaders();
  }

  private loadHeaders() {
    const id: HeaderType = {
      text: this.$t('Id') as string,
      value: 'id',
    };
    const type: HeaderType = {
      text: this.$t('Agent type') as string,
      value: 'type',
    };
    const name: HeaderType = {
      text: this.$t('Agent name') as string,
      value: 'name',
    };
    const country: HeaderType = {
      text: this.$t('Country') as string,
      value: 'country',
    };
    const headers: HeaderType[] = [id, type, name, country];
    this.headers = headers;
  }

  private getAgentTypeText(type: AgentTypeEnum) {
    return this.$t(`AgentTypeEnum.${type}`);
  }

  private getCountryText(country: CountryEnum) {
    return `${this.$t('CountryEnum.' + country)}(${country})`;
  }
}
